<template>
  <svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><title/>
    <g>
      <path fill="#0787C9" d="M45,10H44V9a2.9,2.9,0,0,0-3-3H24V5a3,3,0,0,0-3-3H3A3,3,0,0,0,0,5V45a3,3,0,0,0,3,3H17V46H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H21a1,1,0,0,1,1,1v5H12v2H45a1,1,0,0,1,1,1v8h2V13A3,3,0,0,0,45,10Zm-3,0H24V8H41a.9.9,0,0,1,1,1Z"/>
      <path fill="#0787C9" d="M46,24H22a2,2,0,0,0-2,2V46a2,2,0,0,0,2,2H46a2,2,0,0,0,2-2V26A2,2,0,0,0,46,24ZM22,46v-.6l9-9L40.59,46Zm24,0H43.41l-5.94-5.94,3.59-3.59L46,41.41Zm0-7.41-4.23-4.23a1,1,0,0,0-1.41,0l-4.29,4.29-4.4-4.39A1,1,0,0,0,31,34c-.4,0-.44,0-9,8.58V26H46Z"/>
    </g>
  </svg>
</template>
